import { z } from "zod/v4-mini";

import { cz } from "@/utils/zodUtils";

import { TandemEventDefinition } from "../TandemTypes";

export type BasalDeliveryPayload = {
  commanded_rate_source?: number;
  commanded_rate?: number;
  profile_basal_rate?: number;
  algorithm_rate?: number;
  temp_rate?: number;
};

export type BasalDeliveryEvent = {
  commandedRateSource?: number;
  commandedRate?: number;
  profileBasalRate?: number;
  algorithmRate?: number;
  tempRate?: number;
};

const basalDeliverySchema = z.object({
  commanded_rate_source: cz.permissive(z.number()),
  commanded_rate: cz.permissive(z.number()),
  profile_basal_rate: cz.permissive(z.number()),
  algorithm_rate: cz.permissive(z.number()),
  temp_rate: cz.permissive(z.number()),
});

const getBasalDeliveryRate = (rate: number | undefined) => {
  if (rate === undefined) {
    return undefined;
  }
  if (rate === 0xffff) {
    // default, unset value
    return undefined;
  }
  return rate * 0.001;
};

export const LID_BASAL_DELIVERY = {
  value: 0x117,
  name: "Basal Delivery Event",
  format: "s..ssss....",
  fields: ["commanded_rate_source", "commanded_rate", "profile_basal_rate", "algorithm_rate", "temp_rate"],
  postprocess: rec => ({
    commandedRateSource: rec.commanded_rate_source,
    commandedRate: getBasalDeliveryRate(rec.commanded_rate),
    profileBasalRate: getBasalDeliveryRate(rec.profile_basal_rate),
    algorithmRate: getBasalDeliveryRate(rec.algorithm_rate),
    tempRate: getBasalDeliveryRate(rec.temp_rate),
  }),
  schema: basalDeliverySchema,
} as const satisfies TandemEventDefinition<BasalDeliveryPayload, BasalDeliveryEvent>;
